import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSuperbarFeedback = (
  {
    title,
    titleId,
    desc,
    descId,
    stroke = 'gray',
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 18 18"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#superbar-feedback-clip0_5872_2149)"
    >
      <path d="M16.908 10.054a3.69 3.69 0 0 0-3.69-3.69h-2.11a3.69 3.69 0 1 0 0 7.38h.528l3.163 3.163v-3.531a3.68 3.68 0 0 0 2.109-3.322M5.31 9.529 3.2 11.637v-3.53a3.683 3.683 0 0 1 1.582-7.013h2.11a3.69 3.69 0 0 1 3.536 2.636" />
    </g>
    <defs>
      <clipPath id="superbar-feedback-clip0_5872_2149">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgSuperbarFeedback);
const Memo = memo(ForwardRef);
export default Memo;
